export function ScenarioNotice({
  action,
  children,
  tone = "default",
}: {
  action?: React.ReactNode
  children: React.ReactNode
  tone?: "default" | "warning" | "danger"
}) {
  const classes =
    tone === "danger"
      ? "border-destructive/40 bg-destructive/5"
      : tone === "warning"
        ? "border-warning/40 bg-warning/5"
        : "border-primary/30 bg-primary/5"
  return (
    <div className={`mb-4 rounded-md border p-3 text-sm ${classes}`}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>{children}</div>
        {action && <div className="ml-auto shrink-0">{action}</div>}
      </div>
    </div>
  )
}
